import styled from "styled-components";
import { rgba } from "polished";
import { createButtonStyles } from "../../utils/create-button-styles.es.js";
const UtilityButtonClickArea = styled("button")(
  ({ theme }) => ({
    background: "none",
    border: 0,
    borderRadius: 2,
    color: theme.color.default,
    cursor: "pointer",
    display: "flex",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    outline: 0,
    padding: 0,
    margin: 0,
    position: "relative",
    textDecoration: "none",
    transition: "all 0.3s cubic-bezier(.645, .045, .355, 1)",
    width: "auto"
  }),
  ({
    "aria-expanded": expanded,
    "aria-pressed": pressed,
    theme,
    $displayMode,
    $variant
  }) => ({
    accent: createButtonStyles(
      $displayMode === "dark" ? {
        activeBackgroundColor: rgba("white", 0.35),
        defaultBackgroundColor: expanded || pressed ? rgba("white", 0.35) : rgba("white", 0.15),
        defaultColor: rgba("white", 0.85),
        disabledBackgroundColor: rgba("white", 0.15),
        disabledColor: rgba("white", 0.45),
        focusBoxShadow: `0 0 0 2px ${rgba("white", 0.25)}`,
        hoverBackgroundColor: rgba("white", 0.25)
      } : {
        activeBackgroundColor: theme.color.blue3,
        defaultBackgroundColor: expanded || pressed ? theme.color.blue2 : theme.color.blue1,
        defaultColor: theme.color.blue6,
        disabledBackgroundColor: theme.color.gray3,
        disabledColor: theme.color.gray6,
        focusBoxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`,
        hoverBackgroundColor: theme.color.blue2
      }
    ),
    danger: createButtonStyles({
      activeBackgroundColor: theme.color.gray4,
      defaultBackgroundColor: expanded || pressed ? theme.color.gray3 : void 0,
      defaultColor: theme.color.red6,
      disabledColor: theme.color.gray6,
      focusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
      hoverBackgroundColor: theme.color.gray3
    }),
    default: createButtonStyles(
      $displayMode === "dark" ? {
        activeBackgroundColor: rgba("white", 0.25),
        defaultBackgroundColor: expanded || pressed ? rgba("white", 0.15) : void 0,
        defaultColor: rgba("white", 0.85),
        disabledColor: rgba("white", 0.45),
        focusBoxShadow: `0 0 0 2px ${rgba("white", 0.25)}`,
        hoverBackgroundColor: rgba("white", 0.15)
      } : {
        activeBackgroundColor: theme.color.gray4,
        defaultBackgroundColor: expanded || pressed ? theme.color.gray3 : void 0,
        defaultColor: theme.color.default,
        disabledColor: theme.color.gray6,
        focusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        hoverBackgroundColor: theme.color.gray3
      }
    )
  })[$variant]
);
const UtilityButtonInner = styled("span")(
  {
    alignItems: "center",
    display: "grid",
    gap: 4,
    gridAutoFlow: "column"
  },
  ({ magnitude, inline }) => ({
    medium: {
      lineHeight: "20px",
      padding: inline ? "6px 0" : 6
    },
    small: {
      lineHeight: "16px",
      padding: inline ? "4px 0" : 4
    },
    xsmall: {
      lineHeight: "12px",
      padding: inline ? "4px 0" : 4
    }
  })[magnitude]
);
const UtilityButtonIcon = styled("span")(
  ({ magnitude }) => ({
    medium: {
      fontSize: 20,
      "&:not(:last-child)": {
        paddingRight: 2
      }
    },
    small: {
      fontSize: 16
    },
    xsmall: {
      fontsize: 12
    }
  })[magnitude]
);
const UtilityButtonText = styled("span")({
  // TODO: remove the next two lines to properly support ellipsification (it will be a breaking change)
  alignItems: "center",
  display: "flex",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});
export {
  UtilityButtonClickArea,
  UtilityButtonIcon,
  UtilityButtonInner,
  UtilityButtonText
};
